






import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../system/mixins";
import { StandardOption } from "../../../../../system/selectors/mixins";
import OptionRadioSelector from "../../../../../system/selectors/OptionRadioSelector.vue";
import { Size } from "../../../../../../domain/drawing";

@Component({
  components: {
    selector: OptionRadioSelector,
  }
})
export default class ClaioImageSizeSelector extends Mixins(ModelEditableMixin) {
  static Option: {[key: string]: Size} = {
    small: new Size(80, 80),
    medium: new Size(120, 120),
    large: new Size(160, 160),
  };

  private static SourceItems: StandardOption<Size>[] = [
    ClaioImageSizeSelector.toOption("小", ClaioImageSizeSelector.Option.small),
    ClaioImageSizeSelector.toOption("中", ClaioImageSizeSelector.Option.medium),
    ClaioImageSizeSelector.toOption("大", ClaioImageSizeSelector.Option.large),
  ];

  private static toOption(label: string, size: Size): StandardOption<Size> {
    return new StandardOption<Size>(
      label,
      size,
      "サムネイル画像を" + size.width + "x" + size.height + "サイズで表示します"
    );
  }
  
  get options(): StandardOption<Size>[] {
    return ClaioImageSizeSelector.SourceItems;
  }
}
